import CodeSnippet from '../CodeSnippet';

export default function IntegrateClaudeCode({ apiUrl, tokenPlaceholder }) {
  const base = `${apiUrl || 'https://api.osrouter.dev'}/api/v1`;
  const code = `# ~/.claude/settings.json or shell environment

export ANTHROPIC_BASE_URL="${base}"
export ANTHROPIC_AUTH_TOKEN="${tokenPlaceholder}"`;

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-2">Claude Code</h1>
      <p className="text-sm opacity-60 mb-6">
        Point Claude Code at os-router by setting the Anthropic base URL and auth token in your environment.
      </p>
      <CodeSnippet code={code} language="bash" />
      <p className="text-sm opacity-60 mt-4">
        Restart Claude Code after updating your environment variables.
      </p>
    </div>
  );
}
